import {
  GET_LMSS_REQUEST,
  GET_LMSS_SUCCESS,
  GET_LMSS_ERROR,
  GET_LMS_REQUEST,
  GET_LMS_SUCCESS,
  GET_LMS_ERROR,
  CREATE_LMS_REQUEST,
  CREATE_LMS_SUCCESS,
  CREATE_LMS_ERROR,
  EDIT_LMS_REQUEST,
  EDIT_LMS_SUCCESS,
  EDIT_LMS_ERROR,
  DELETE_LMS_REQUEST,
  DELETE_LMS_SUCCESS,
  DELETE_LMS_ERROR
} from "@/actions"

import {
  lmsService
} from "@/services"

import { addNewFilter, decodeLaravelValidationErrors, isEmpty } from "@/utilities"

const state = {
  lmss: [],
  lms: {},
  loading: false,
  loadedOnce: false
}

const getters = {
  lmsLoadedOnce: state => state.loadedOnce,
  lms: state => state.lms,
  lmss: state => state.lmss,
  lmsSelectOptions: state => {
    return state.lmss.map(lms => {
      return { value: lms.uuid, label: lms.name }
    }).sort((a, b) => a.label.localeCompare(b.label))
  },
  lmsMultiSelectOptions: state => {
    return state.lmss.map(lms => {
      return { value: lms.uuid, text: lms.name }
    }).sort((a, b) => a.text.localeCompare(b.text))
  },
  lmsNoneOption: state => state.lmss.find(lms => lms.slug == "NONE")
}

const actions = {
  async getLmss({ commit }) {
    commit("GET_LMSS_REQUEST")
    const response = await lmsService.getLmss();
    const { status, data } = response
    switch (status) {
      case 200:
        commit("GET_LMSS_SUCCESS", data)
        break
      default:
        commit("GET_LMSS_ERROR")
    }
    return response
  },
  async getLms({ commit }, params) {
    commit("GET_LMS_REQUEST")
    const response = await lmsService.getLms(params)
    const { status, data } = response
    switch (status) {
      case 200:
        commit("GET_LMS_SUCCESS", data)
        break
      default:
        commit("GET_LMS_ERROR")
        break
    }
    return response
  },
  async createLms({ commit, dispatch }, params) {
    commit("CREATE_LMS_REQUEST")
    const response = await lmsService.createLms(params)
    const { status, data } = response
    switch (status) {
      case 200:
        if (data?.success) {
          commit("CREATE_LMS_SUCCESS", data);
          dispatch("alert/createAlertSuccess", "Learning management system created. ", { root: true })
        }

        if (data?.error) {
          commit("CREATE_LMS_ERROR");
          dispatch("alert/createAlertErrors", data.errors ? decodeLaravelValidationErrors(data.errors) : "Oops. Something went wrong. LMS not created.", { root: true })
        }

        break
      default:
        commit("CREATE_LMS_ERROR")
    }
    return response
  },
  async editLms({ commit, dispatch }, params) {
    commit("EDIT_LMS_REQUEST")
    const response = await lmsService.editLms(params)
    const { status, data } = response
    switch (status) {
      case 200:
        if (data?.success) {
          commit("EDIT_LMS_SUCCESS", data);
          dispatch("alert/createAlertSuccess", "Learning management system updated. ", { root: true })
        }

        if (data?.error) {
          commit("EDIT_LMS_ERROR");
          dispatch("alert/createAlertErrors", data.errors ? decodeLaravelValidationErrors(data.errors) : "Oops. Something went wrong. LMS not updated.", { root: true })
        }

        break
      default:
        commit("EDIT_LMS_ERROR")
    }
    return response
  },
  async deleteLms({ commit, dispatch }, uuid) {
    commit("DELETE_LMS_REQUEST")
    const response = await lmsService.deleteLms(uuid)
    const { status, data } = response
    switch (status) {
      case 200:
        if (data?.success) {
          const { lms } = data
          commit("DELETE_LMS_SUCCESS", { ...lms, uuid} );
          dispatch("alert/createAlertSuccess", "Learning management system deleted. ", { root: true })
        }

        if (data?.error) {
          commit("DELETE_LMS_ERROR");
          dispatch("alert/createAlertErrors", data.errors ? decodeLaravelValidationErrors(data.errors) : "Oops. Something went wrong. LMS not deleted.", { root: true })
        }

        break
      default:
        commit("DELETE_LMS_ERROR")
    }
    return response
  }
}

const mutations = {
  [GET_LMSS_REQUEST]: state => {
    state.loading = true
  },
  [GET_LMSS_SUCCESS]: (state, data) => {
    const lmss = [...data.learning_management_systems]
    state.lmss = addNewFilter(state.lmss, lmss)
    state.loading = false
    state.loadedOnce = true
  },
  [GET_LMSS_ERROR]: state => {
    state.loading = false
    state.error = true
  },
  [GET_LMS_REQUEST]: state => {
    state.loading = true
  },
  [GET_LMS_SUCCESS]: (state, data) => {
    const { lms } = data;
    state.lmss = addNewFilter(state.lmss, [lms])
    state.loading = false
  },
  [GET_LMS_ERROR]: (state, data) => {
    state.loading = false
  },

  [CREATE_LMS_REQUEST]: state => {
    state.loading = true
  },
  [CREATE_LMS_SUCCESS]: (state, data) => {
    const { lms } = data;
    state.lmss = addNewFilter(state.lmss, [lms])
    state.loading = false
  },
  [CREATE_LMS_ERROR]: state => {
    state.loading = false
  },

  [EDIT_LMS_REQUEST]: state => {
    state.loading = true
  },
  [EDIT_LMS_SUCCESS]: (state, data) => {
    const { lms } = data;
    state.lmss = addNewFilter(state.lmss, [lms])
    state.loading = false
  },
  [EDIT_LMS_ERROR]: state => {
    state.loading = false
  },

  [DELETE_LMS_REQUEST]: state => {
    state.loading = true
  },
  [DELETE_LMS_SUCCESS]: (state, lms) => {
    const { uuid, deleted_at } = lms;

    if (!isEmpty(deleted_at)) {
      state.lmss = addNewFilter(state.lmss, [lms])
    } else {
      state.lmss = state.lmss.filter(lms => lms.uuid !== uuid)
    }

    state.loading = false
  },
  [DELETE_LMS_ERROR]: (state) => {
    state.loading = false
  }

}

export const lms = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
